import React, { useState, useEffect } from "react";
import { changePasswordSSO, getUserSSO, updateProfile } from '../../apirapper/user.ts';
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useSelector } from 'react-redux';
import { useDispatch } from "react-redux";
import { setFullName } from "../../core/redux/action";
import { requestForToken } from '../../firebase';
// import { messaging } from "../../utils/firebaseUtils";

const Profile = () => {
  const MySwal = withReactContent(Swal);
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");
  const dispatch = useDispatch();
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    email: ""
  });
  const [loading, setLoading] = useState(true);
  //Permissions  
  const permissions = useSelector(state => state.permissions) || [];
  const roleTitle = useSelector(state => state.roleTitle) || '';
  const roleTitleAdmin = useSelector(state => state.roleTitleAdmin) || '';

  const canView = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'profile' && p.Permission.toLowerCase() === 'view');
  const canUpdate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'profile' && p.Permission.toLowerCase() === 'update');


  const [errors, setErrors] = useState({});
  const [errorsPass, setErrorsPass] = useState({});
  const [currentPassword, setCurrentPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [fcmToken, setFcmToken] = useState({});
  const [notificationsEnabled, setNotificationsEnabled] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setLoading(true);
        const response = await getUserSSO();
        const deviceCheck = response.response.userDetails.devices;
        console.log('deviceCheck devices', deviceCheck);

        // console.log('response devices', response.response.userDetails.devices);
        try
        {
          const token = await requestForToken();//"";//await messaging();

          const tokenData = { id: token, os: "web" };
          setFcmToken(tokenData);
          if(deviceCheck)
            setNotificationsEnabled(true);
          else
            setNotificationsEnabled(false);
        }
        catch(e)
        {
          setFcmToken({});
          setNotificationsEnabled(false);
        }
        console.log('response', response.response.userDetails.profile);
        const userDetails = response.response.userDetails;
        const profile = userDetails.profile;
        // Update state with user data
        setUserData({
          firstName: profile.firstName,
          lastName: profile.lastName,
          email: userDetails.email
        });
        
      } catch (error) {
        console.error('Error fetching user data', error);
      } finally{
        setLoading(false)
      }
    };

    fetchUserData();
  }, []);

  const handleTogglePassword = () => {
    setShowCurrentPassword((prevShowPassword) => !prevShowPassword);
  };

  
  const handleToggleConfirmPassword = () => {
    setShowConfirmPassword((prevShowPassword) => !prevShowPassword);
  };
  const handleToggleNewPassword = () => {
    setShowNewPassword((prevShowPassword) => !prevShowPassword);
  };

  const validatePassword = () => {
    const errorsPass = {};
    if (!currentPassword.trim()) {
      errorsPass.currentPassword = "please_add_current_password";
    }
    if (!confirmPassword.trim()) {
      errorsPass.confirmPassword = "please_confirm_the_password";
    }
    if (!newPassword.trim()) {
      errorsPass.newPassword = "please_add_a_new_password";
    }

    if (confirmPassword.trim() != newPassword.trim()) {
      errorsPass.newPassword = "new_password_and_confirm_password_should_be_same";
    }
    
    setErrorsPass(errorsPass);
    return Object.keys(errorsPass).length === 0;
  };

  const validateProfile = () => {
    const errors = {};
    if (!userData.firstName.trim()) {
      errors.firstName = "Please add a first name.";
    }
    if (!userData.lastName.trim()) {
      errors.lastName = "Please add a last name.";
    }

  
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (validatePassword()) {
      let passwordUpdateData = {
        oldPassword: currentPassword,
        newConfirmPassword: confirmPassword,
        newPassword: newPassword
      };

      try {
        const response = await changePasswordSSO(passwordUpdateData);
        console.log('Change password response',response);
        if (typeof response === 'string' && response.includes('Invalid password')) {

          MySwal.fire({
            position: "top-end",
            icon: "error",
            title: t?.[l]?.["failed_to_update"] || "Your current password is incorrect!",
            showConfirmButton: false,
            timer: 3000,
          });
        }
        else if(response)
        {
          MySwal.fire({
            position: "top-end",
            icon: "success",
            title: t?.[l]?.["password_changed_succesfully!"] || "Password Changed Succesfully!",
            showConfirmButton: false,
            timer: 3000,
          });
        }
        // Show a success message or toaster
      } catch (error) {
        console.error('Error changing password', error);
        
        setErrorsPass({ general: 'Failed to update password.' });
      }
    }
  };

  const handleSaveProfile = async (e) => {
    e.preventDefault();
    if (validateProfile()) {
      try {
 
        const updatedData = { ...userData };
        if (notificationsEnabled) {
          updatedData.device = fcmToken;
        }
        delete updatedData.email;

        const response = await updateProfile(updatedData);


    //    const response = await updateProfile(userData);  // Update profile data via API
   // let fullName = `${userData.firstName} ${userData.lastName}`;
    
    var fullName = userData.firstName || undefined;
				if(userData.lastName){
					fullName = userData.firstName+' '+userData.lastName;
				}
        dispatch(setFullName(fullName));
        localStorage.setItem('fullName',fullName);
        
        console.log("fullname",localStorage.getItem('fullName'));
        if(response)
          {
            MySwal.fire({
              position: "top-end",
              icon: "success",
              title: t?.[l]?.["profile_updated_successfully!"] || "Profile updated successfully!",
              showConfirmButton: false,
              timer: 3000,
            });
          }
        // Show a success message or toaster
      } catch (error) {
        console.error('Error updating profile', error);
        setErrors({ general: 'Failed to update profile.' });
      }
    }
  };
  const handleCheckboxChange = (e) => {
    setNotificationsEnabled(e.target.checked);
  };
  if (loading) {
    return (
      <div className="page-wrapper dashboard-wrapper">
        <div className="dashboard-content loader-content">
          <div id="global-loader">
            <div className="whirly-loader"></div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="page-wrapper">
       {canView ? (
      <div className="content">
        <div className="card">
          <div className="card-body">
            <div className="profile-set">
              <div className="profile-top">
              </div>
            </div>
            <div className="input-blocks">
              <h3> {t[l]?.["my_profile"] || 'My Profile'}</h3>
              <hr/>
            </div>
           
            <div className="row">
              <div className="col-lg-6 col-sm-12">
                <div className="input-blocks">
                  <label className="form-label"> {t[l]?.["first_name"] || 'First Name'}</label>
                  <input
                    type="text"
                    className="form-control"
                    value={userData.firstName}
                    required="required"
                    onChange={(e) => setUserData({ ...userData, firstName: e.target.value })}
                  />
                  {errors.firstName && (
                    <span className="text-danger">{errors.firstName}</span>
                  )}
                </div>
              </div>
              <div className="col-lg-6 col-sm-12">
                <div className="input-blocks">
                  <label className="form-label">{t[l]?.["last_name"] || 'Last Name'}</label>
                  <input
                    type="text"
                    className="form-control"
                    value={userData.lastName}
                    required="required"
                    onChange={(e) => setUserData({ ...userData, lastName: e.target.value })}
                  />
                  {errors.lastName && (
                    <span className="text-danger">{errors.lastName}</span>
                  )}
                </div>
              </div>
        
              <div className="col-lg-6 col-sm-12">
                <div className="input-blocks">
                  <label>{t[l]?.["email"] || 'Email'}</label>
                  <input
                    type="email"
                    className="form-control"
                    value={userData.email}
                    required="required"
                    disabled
                  />
                  {errors.email && (
                    <span className="text-danger">{errors.email}</span>
                  )}
                </div>
              </div>

              <div className="col-lg-6 col-sm-12">
                <div className="input-blocks">
                  <label>{t[l]?.["enable_notifications"] || 'Enable Notifications'}</label>

                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="enableNotifications"
                      checked={notificationsEnabled}
                      onChange={handleCheckboxChange}
                    />

                  </div>
                </div>
          
              <div className="col-12">
              { canUpdate&&(
                <Link onClick={handleSaveProfile} className="btn btn-submit me-2">
                {t[l]?.["save_changes"] || 'Save Changes'}
                </Link>) 
                // :(
                //   <Link to="#" className="btn btn-submit me-2 disabled">
                //   {t[l]?.["save_changes"] || 'Save Changes'}
                //   </Link>
                }
              </div>
            </div>
          </div>

          <div className="card-body">
            <div className="profile-set">
              <div className="profile-top">
                <div className="profile-content">
                </div>
              </div>
            </div>
            <div className="input-blocks">
              <h3>    {t[l]?.["change_password"] || 'Change Password'}</h3>
              <hr/>
            </div>
            <div className="row">
              <div className="col-lg-12 col-sm-12">
                <div className="input-blocks">
                  <label className="form-label"> {t[l]?.["current_password"] || 'Current Password'}</label>
                  <div className="pass-group">
                  <input
                    type={showCurrentPassword ? "text" : "password"}
                    className="pass-input"
                    value={currentPassword}
                    // onChange={(e) => setCurrentPassword(e.target.value)}
                    onChange={(e) => {
                      setCurrentPassword(e.target.value);
                      setErrorsPass((prevErrors) => ({
                        ...prevErrors,
                        currentPassword: ""
                      }));
                    }}
                  />
                  <span
                    className={`fas toggle-password ${
                      showCurrentPassword ? "fa-eye" : "fa-eye-slash"
                    }`}
                    onClick={handleTogglePassword}
                    
                  /> 
                  </div>               
                  {/* {t[l]?.["please_add_current_password"]} */}
                  {errorsPass.currentPassword && (
                      <span className="text-danger">{t[l]?.[errorsPass.currentPassword] || "Please add current password."}</span>
                    )}
                
                </div>
              </div>
              <div className="col-lg-12 col-sm-12">
                <div className="input-blocks">
                  <label className="form-label"> {t[l]?.["new_password"] || 'New Password'}</label>
                  <div className="pass-group">
                  <input
                     type={showConfirmPassword ? "text" : "password"}
                    className="form-control"
                    value={newPassword}
                    // onChange={(e) => setNewPassword(e.target.value)

                    //   errorsPass.newPassword =""
                    // }

                    onChange={(e) => {
                      setNewPassword(e.target.value);
                      setErrorsPass((prevErrors) => ({
                        ...prevErrors,
                        newPassword: ""
                      }));
                    }}
                  />
                  <span
                    className={`fas toggle-password ${
                      showConfirmPassword ? "fa-eye" : "fa-eye-slash"
                    }`}
                    onClick={handleToggleConfirmPassword}
                    
                  /> 
                  </div>  
                  {errorsPass.newPassword && (
                      <span className="text-danger">{t[l]?.[errorsPass.newPassword] || "New Password and Confirm Password Should be same."}</span>
                    )}
                </div>
              </div>
        
              <div className="col-lg-12 col-sm-12">
                <div className="input-blocks">
                  <label>{t[l]?.["confirm_password"] || 'Confirm Password'}</label>
                  <div className="pass-group">
                  <input
                      type={showNewPassword ? "text" : "password"}
                    className="form-control"
                    value={confirmPassword}
                    onChange={(e) => {
                      setConfirmPassword(e.target.value);
                      setErrorsPass((prevErrors) => ({
                        ...prevErrors,
                        confirmPassword: ""
                      }));
                    }}
                  />
                   <span
                    className={`fas toggle-password ${
                      showNewPassword ? "fa-eye" : "fa-eye-slash"
                    }`}
                    onClick={handleToggleNewPassword}
                    
                  /> 
                  </div>  
                  {errorsPass.confirmPassword && (
                      <span className="text-danger">{t[l]?.[errorsPass.confirmPassword] || "Please add confirm password."}</span>
                    )}
                </div>
              </div>
           
              <div className="col-12">
                <Link onClick={handleChangePassword} className="btn btn-submit me-2">
                {t[l]?.["save_changes"] || 'Save Changes'}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
       ):(
       <div className="content">
        <p>{t[l]?.["no_permission"] || "You do not have permission to view this page."}</p>
       </div>)}
    </div>
  );
};

export default Profile;

// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import { changePasswordSSO, getUserSSO } from '../../apiwrapper/user.ts';

// import { useNavigate } from "react-router-dom";
// import ImageWithBasePath from "../../core/img/imagewithbasebath";
// import { Link } from "react-router-dom";

// import { all_routes } from "../../Router/all_routes";

// // JSON data for countries and states
// import countriesData from "../pages/profiledetail/countries.json";
// import statesData from "../pages/profiledetail/states.json";

// const Profile = () => {
//   const route = all_routes;
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [userData, setUserData] = useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     phoneNumber: ""
//   });

  
//   const [errors, setErrors] = useState({});
//   const [errorsPass, setErrorsPass] = useState({});

//   const [currentPassword, setCurrentPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [newPassword, setNewPassword] = useState("");

//   useEffect(() => {
//     const fetchUserData = async () => {
//       try {
//         const response = await getUserSSO();
//         console.log('response',response.response.userDetails.profile)
//         const userDetails = response.response.userDetails;
//         const profile = userDetails.profile;
//         // Update state with user data
//         setUserData({
//           firstName: profile.firstName,
//           lastName: profile.lastName,
//           email: userDetails.email, 
//           phoneNumber: userDetails.phoneNumber || "" // Set to empty string if no phone
//         });
        
//     } catch (error) {
//         console.error('Error fetching user data', error);
//       }
//     };

//     fetchUserData();
//   }, []);

//   const validatePassword = () => {
//     const errorsPass = {};
//     if (!currentPassword.trim()) {
//       errorsPass.currentPassword = "Please add current password.";
//     }
//     if (!confirmPassword.trim()) {
//       errorsPass.confirmPassword = "Please add current password.";
//     }
//     if (!newPassword.trim()) {
//       errorsPass.newPassword = "Please add new password.";
//     }
    
//     setErrorsPass(errorsPass);
//     return Object.keys(errorsPass).length === 0;
//   };
//   const validate = () => {
//     const errorsPass = {};
//     //if (!userData.firstName.trim()) {
//     //   errorsPass.firstName = "Please add first name.";
//     // }
//     if (!userData.firstName.trim()) {
//       errorsPass.firstName = "Please add current password.";
//     }
  
//     setErrorsPass(errorsPass);
//     return Object.keys(errorsPass).length === 0;
//   };
  
//   //()
//   const handleChangePassword = async (e) => {
//     e.preventDefault();
//     if (validatePassword()) {
      
//       let passwordUpdateData = {
//         oldPassword: currentPassword,
//         newConfirmPassword: confirmPassword,
//         newPassword: newPassword
//       };
// //passwordUpdateData

// try {
//   const response = await changePasswordSSO(passwordUpdateData);
//   console.log('resp',response);
//   //add a toaster password updated
// } catch (error) {
//   console.error('SignIn Error', error);
//   setErrors({ general: 'Invalid email or password' });
// }

//       console.log('passwordUpdateData',passwordUpdateData); 
//      //show toaster
//     }
//   };
//   const handleSaveProfile = (e) => {
//     e.preventDefault();
//     //userData
//     if (validate()) {

//       console.log('userData',userData); // You can send this formData to the next step/component
//     }
//   };

// //getUserSSO
//   return (
//     <div className="page-wrapper">
//       <div className="content">
       
//         {/* /product list */}
//         <div className="card">
//           <div className="card-body">
//             <div className="profile-set">
//               <div className="profile-top">
//                 {/* <div className="profile-content">
//                   <div className="profile-contentimg">
//                     <ImageWithBasePath
//                       src="assets/img/profileimg.png"
//                       alt="img"
//                       id="blah"
//                     />
//                     <div className="profileupload">
//                       <input type="file" id="imgInp" />
//                      <Link to="#">
//                         <ImageWithBasePath src="assets/img/icons/edit-set.svg" alt="img" />
//                       </Link>
//                     </div>
//                   </div>
//                   <div className="profile-contentname">
//                     <h2>Nabeel Rehan</h2>
//                     <h4>Updates Your Photo and Personal Details.</h4>
//                   </div>
//                 </div> */}
                
//               </div>
//             </div>
         
//             <div className="input-blocks">
//               <h3>My Profile</h3>
//               <hr/>
//             </div>
           
//             <div className="row">
//               <div className="col-lg-6 col-sm-12">
//                 <div className="input-blocks">
//                 <label className="form-label">First Name</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={userData.firstName}
//                     required="required"
//                     onChange={(e) => setUserData({ ...userData, firstName: e.target.value })}
//                   />
//                    {errors.firstName && (
//                         <span className="text-danger">{errors.firstName}</span>
//                       )}
//                 </div>
//               </div>
//               <div className="col-lg-6 col-sm-12">
//                 <div className="input-blocks">
//                 <label className="form-label">Last Name</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     required="required"
//                     value={userData.lastName}
//                     onChange={(e) => setUserData({ ...userData, lastName: e.target.value })}
//                   />
//                    {errors.lastName && (
//                         <span className="text-danger">{errors.lastName}</span>
//                       )}
//                 </div>
//               </div>
        
//               <div className="col-lg-6 col-sm-12">
//                 <div className="input-blocks">
//                   <label>Email</label>
//                   <input
//                     type="email"
//                     className="form-control"
//                     required="required"
//                     value={userData.email}
//                     onChange={(e) => setUserData({ ...userData, email: e.target.value })}
//                   />
//                    {errors.email && (
//                         <span className="text-danger">{errors.email}</span>
//                       )}
//                 </div>
//               </div>
//               <div className="col-lg-6 col-sm-12">
//                 <div className="input-blocks">
//                   <label className="form-label">Phone</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     required="required"
//                     value={userData.phoneNumber}
//                     onChange={(e) => setUserData({ ...userData, phoneNumber: e.target.value })}
//                   />
//                    {errors.phoneNumber && (
//                         <span className="text-danger">{errors.phoneNumber}</span>
//                       )}
//                 </div>
//               </div>
          
//               <div className="col-12">
//                <Link onClick={handleSaveProfile} className="btn btn-submit me-2">
//                Save Changes
//                 </Link>
//               </div>
//             </div>
//           </div>

//           <div className="card-body">
//             <div className="profile-set">
//               <div className="profile-top">
//                 <div className="profile-content">
//                 </div>
//               </div>
//             </div>
//             <div className="input-blocks">
//               <h3>Change Password</h3>
//               <hr/>
//             </div>
//             <div className="row">
//               <div className="col-lg-12 col-sm-12">
//                 <div className="input-blocks">
//                   <label className="form-label">Current Password</label>
//                   <input
//                     type="password"
//                     className="form-control"
//                     value={currentPassword}
//                     onChange={(e) => setCurrentPassword(e.target.value)}
//                   />                    
//                   {errorsPass.currentPassword && (
//                       <span className="text-danger">{errorsPass.currentPassword}</span>
//                     )}
                
//                 </div>
//               </div>
//               <div className="col-lg-12 col-sm-12">
//                 <div className="input-blocks">
//                   <label className="form-label">New Password</label>
//                   <input
//                     type="password"
//                     className="form-control"
//                     value={newPassword}
//                     onChange={(e) => setNewPassword(e.target.value)}
//                   />
//                   {errorsPass.newPassword && (
//                       <span className="text-danger">{errorsPass.newPassword}</span>
//                     )}
//                 </div>
//               </div>
        
//               <div className="col-lg-12 col-sm-12">
//                 <div className="input-blocks">
//                   <label>Confirm Password</label>
//                   <input
//                     type="password"
//                     className="form-control"
//                     value={confirmPassword}
//                     onChange={(e) => setConfirmPassword(e.target.value)}
//                   />
//                   {errorsPass.confirmPassword && (
//                       <span className="text-danger">{errorsPass.confirmPassword}</span>
//                     )}
                    
//                 </div>
//               </div>
           
//               <div className="col-12">
//                <Link onClick={handleChangePassword} className="btn btn-submit me-2">
//                   Save Changes
//                 </Link>
              
//               </div>
//             </div>
//           </div>
//         </div>
//         {/* /Update PAssword */}

//       </div>
//     </div>
//   );
// };

// export default Profile;

//     {/* <hr />
//               <div className="col-lg-6 col-sm-12">
//                 <div className="input-blocks">
//                   <label className="form-label">Country</label>
                  
//                     <select
//                       className="form-control"
//                       value={selectedCountry}
//                       onChange={(e) => setSelectedCountry(e.target.value)}
//                     >
//                       <option value="">Select Country</option>
//                       {countriesData.map((country) => (
//                         <option key={country.code} value={country.code}>
//                           {country.name}
//                         </option>
//                       ))}
//                     </select>

//                   {errors.country && (
//                     <span className="text-danger">{errors.country}</span>
//                   )}
//                   </div>
//                 </div>
//                 <div className="col-lg-6 col-sm-12">
//                   <div className="input-blocks">
//                     <label className="form-label">State</label>
//                       <select
//                         className="form-control"
//                         value={selectedState}
//                         onChange={(e) => setSelectedState(e.target.value)}
//                       >
//                         <option value="">Select State</option>
//                         {filteredStates.map((state) => (
//                           <option key={state.code} value={state.code}>
//                             {state.name}
//                           </option>
//                         ))}
//                       </select>
                    
//                       {errors.state && (
//                         <span className="text-danger">{errors.state}</span>
//                       )}
//                   </div>
//                 </div>
//                 <div className="col-lg-6 col-sm-12">
//                   <div className="input-blocks">
//                     <label className="form-label">Zip Code</label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         value={zipCode}
//                         onChange={(e) => setZipCode(e.target.value)}
//                       />
                     
//                     {errors.zipCode && (
//                       <span className="text-danger">{errors.zipCode}</span>
//                     )}
//                   </div>
//                 </div>
//                 <div className="col-lg-6 col-sm-12">
//                   <div className="input-blocks">
//                     <label className="form-label">Area</label>
//                     <input
//                         type="text"
//                         className="form-control"
//                         value={area}
//                         onChange={(e) => setArea(e.target.value)}
//                       />
                     
//                     {errors.area && (
//                       <span className="text-danger">{errors.area}</span>
//                     )}
//                   </div>
//                 </div>
//                 <div className="col-lg-6 col-sm-12">
//                   <div className="input-blocks">
//                     <label className="form-label">Store Address</label>
//                     <textarea
//                         className="form-control"
//                         value={address}
//                         onChange={(e) => setAddress(e.target.value)}
//                       />
                      
//                       {errors.address && (
//                         <span className="text-danger">{errors.address}</span>
//                       )}
//                   </div>
//                 </div>
//             */}
// import React from "react";
// import ImageWithBasePath from "../../core/img/imagewithbasebath";
// import { Link } from "react-router-dom";

// const Profile = () => {
//   return (
//     <div className="page-wrapper">
//       <div className="content">
//         <div className="page-header">
//           <div className="page-title">
//             <h4>Profile</h4>
//             <h6>User Profile</h6>
//           </div>
//         </div>
//         {/* /product list */}
//         <div className="card">
//           <div className="card-body">
//             <div className="profile-set">
//               <div className="profile-head"></div>
//               <div className="profile-top">
//                 <div className="profile-content">
//                   <div className="profile-contentimg">
//                     <ImageWithBasePath
//                       src="assets/img/customer/customer5.jpg"
//                       alt="img"
//                       id="blah"
//                     />
//                     <div className="profileupload">
//                       <input type="file" id="imgInp" />
//                      <Link to="#">
//                         <ImageWithBasePath src="assets/img/icons/edit-set.svg" alt="img" />
//                       </Link>
//                     </div>
//                   </div>
//                   <div className="profile-contentname">
//                     <h2>William Castillo</h2>
//                     <h4>Updates Your Photo and Personal Details.</h4>
//                   </div>
//                 </div>
                
//               </div>
//             </div>
//             <div className="row">
//               <div className="col-lg-6 col-sm-12">
//                 <div className="input-blocks">
//                   <label className="form-label">First Name</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     defaultValue="William"
//                   />
//                 </div>
//               </div>
//               <div className="col-lg-6 col-sm-12">
//                 <div className="input-blocks">
//                   <label className="form-label">Last Name</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     defaultValue="Castilo"
//                   />
//                 </div>
//               </div>
//               <div className="col-lg-6 col-sm-12">
//                 <div className="input-blocks">
//                   <label>Email</label>
//                   <input
//                     type="email"
//                     className="form-control"
//                     defaultValue="william@example.com"
//                   />
//                 </div>
//               </div>
//               <div className="col-lg-6 col-sm-12">
//                 <div className="input-blocks">
//                   <label className="form-label">Phone</label>
//                   <input type="text" defaultValue="+1452 876 5432" />
//                 </div>
//               </div>
//               <div className="col-lg-6 col-sm-12">
//                 <div className="input-blocks">
//                   <label className="form-label">User Name</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     defaultValue="William Castilo"
//                   />
//                 </div>
//               </div>
//               <div className="col-lg-6 col-sm-12">
//                 <div className="input-blocks">
//                   <label className="form-label">Password</label>
//                   <div className="pass-group">
//                     <input
//                       type="password"
//                       className="pass-input form-control"
//                     />
//                     <span className="fas toggle-password fa-eye-slash" />
//                   </div>
//                 </div>
//               </div>
//               <div className="col-12">
//                <Link to="#" className="btn btn-submit me-2">
//                   Submit
//                 </Link>
//                <Link to="#" className="btn btn-cancel">
//                   Cancel
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>
//         {/* /product list */}
//       </div>
//     </div>
//   );
// };

// export default Profile;
